/**
 * 文件下载中间件
 * @param ctx
 * @param next
 * @returns
 */
export const downloadMiddleware = async (ctx, next) => {
  const {
    cgiInfo,
    requestConfig,
    collectionId,
    cgiName
  } = ctx;
  const isBlob = cgiInfo.responseType === 'blob';
  if (isBlob) {
    requestConfig.responseType = 'blob';
  }
  await next();
  if (isBlob) {
    console.log(`数据源请求[${collectionId}/${cgiName}] responseType=blob,进行文件下载`);
    if (ctx.response) {
      downloadFromAxiosResponse(ctx.response, cgiName);
    }
  }
};
function getFileNameFromContentDisposition(contentDisposition = '') {
  if (typeof contentDisposition !== 'string') {
    return null;
  }
  const match = contentDisposition.match(/\w+;\s*filename="?([^";]+)"?/);
  if (match) {
    return match[1];
  }
  return null;
}
function downloadFromAxiosResponse(response, fileName = 'default') {
  const {
    data,
    headers
  } = response;
  const blob = new Blob([data], {
    type: headers['content-type']
  });
  const dom = document.createElement('a');
  const url = window.URL.createObjectURL(blob);
  dom.href = url;
  dom.download = decodeURI(getFileNameFromContentDisposition(headers['content-disposition']) || fileName);
  dom.style.display = 'none';
  document.body.appendChild(dom);
  dom.click();
  document.body.removeChild(dom);
  window.URL.revokeObjectURL(url);
}
//# sourceMappingURL=download.js.map
